var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconDownload = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M10 0a1 1 0 0 1 1 1v9.584l3.293-3.291a1 1 0 0 1 1.414 1.414l-5 5a1 1 0 0 1-.088.079l.088-.079a1 1 0 0 1-.395.243l-.02.007-.063.017-.026.005A1 1 0 0 1 10 14h-.032l-.054-.004-.03-.003-.027-.003-.086-.016-.032-.008-.03-.01-.02-.006a1 1 0 0 1-.396-.243l-5-5a1 1 0 0 1 1.414-1.414L9 10.585V1a1 1 0 0 1 1-1m8 17a1 1 0 0 1 0 2H2a1 1 0 0 1 0-2z"
})));
export default SvgIconDownload;